import React from 'react'

const About = () => {
    return (
      <div className="aboutMe">
        <div className="container">
          <div className="aboutMe__container">
            <div>
              <h1>
                <span>HELLO.</span> <br />
                <span>I'm</span>
                <br />
                <span>OLALEKAN</span>
              </h1>
            </div>
            <div>
              <h2>
                <span>Web &</span> <br />
                <span>Mobile App</span>
                <br />
                <span>Developer</span>
              </h2>
            </div>
            <div className="my-5">
              <h1>About Me</h1>I am a Nigerian (🇳🇬) based Web and Mobile App
              Developer who has in the last couple of years been crafting
              awesomeness with my skills. Developing intuitive user interfaces
              for a snappy web & mobile experience.
              <br />
              <strong className="my-5">
                Lastly, i'm also doing and learning things with microsoft as a
                Microsoft student Learn Ambassador.🤫😋🥰
              </strong>
            </div>
          </div>
        </div>
      </div>
    );
}

export default About
